import { Product } from '@/types'
import Container from './Container'
import { Tile, ExperienceImage, Wrapper } from './ProductCarouselTall.styles'
import { FullWidthSwiper, SwiperButtons, SwiperHeadingContainer, SwiperLeft, SwiperRight } from './Swiper.styles'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { generateHtmlSafeId } from '@/helpers/WidgetHelper'

const ProductCarouselTall: React.FC<{ products: Product[]; label: string }> = ({ products, label }) => {
  const componentId = generateHtmlSafeId(label)
  const prev = `${componentId}-prev`
  const next = `${componentId}-next`

  return (
    <>
      <Wrapper data-mcp-id="product-carousel-tall" data-testid="home-experiences">
        <Container spacing="XL">
          <SwiperHeadingContainer>
            {label && <Heading size="XL">{label}</Heading>}
            <SwiperButtons>
              <SwiperLeft className={prev}></SwiperLeft>
              <SwiperRight className={next}></SwiperRight>
            </SwiperButtons>
          </SwiperHeadingContainer>
        </Container>
        <FullWidthSwiper>
          <Swiper
            modules={[Navigation]}
            navigation={{ prevEl: `.${prev}`, nextEl: `.${next}` }}
            breakpoints={{
              0: {
                spaceBetween: 16,
                slidesPerView: 'auto',
                loop: false,
              },
              720: {
                spaceBetween: 24,
                slidesPerView: 'auto',
                loop: true,
              },
            }}
          >
            {products.map(({ image, title, url }) => (
              <SwiperSlide className="fw-swiper-tile" key={url}>
                <Tile href={`${url}`} key={url}>
                  <ExperienceImage image={image} />
                  <Heading size="S" bold={false} spacing={false}>
                    {title}
                  </Heading>
                </Tile>
              </SwiperSlide>
            ))}
          </Swiper>
        </FullWidthSwiper>
      </Wrapper>

      <Spacing size="XXXL" />
    </>
  )
}

export default ProductCarouselTall
